import type { WorkflowInvoice } from '../../types/workflowInvoice';

/** Upload/extraction responses may omit lines. They update metadata only;
 * business edits and loaded collections remain owned by the editor. */
export function mergeInvoiceSourceMetadata(current: WorkflowInvoice, server: WorkflowInvoice): WorkflowInvoice {
  return {
    ...current,
    id: server.id,
    version: server.version,
    status: server.status,
    sourceFileName: server.sourceFileName,
    sourceFiles: server.sourceFiles,
    extractionStatus: server.extractionStatus,
    extractionError: server.extractionError,
    extractionModel: server.extractionModel,
    extractionSeq: server.extractionSeq,
    lastAppliedExtractionSeq: server.lastAppliedExtractionSeq,
  };
}
